window.$ = window.jQuery = require('jquery');
require('../semantic/semantic');
require('../fotorama/fotorama');

function makeString(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

$(function() {
    $('.car-selector').dropdown({
        placeholder: 'Modèle',
        ignoreCase: true,
        clearable: true,
        fullTextSearch: true,
        forceSelection: false,
        message: {
            noResults: 'Aucun modèle trouvé.'
        }
    });

    $('.gallery').modal();
    $('.gallery-opener').on('click', function() {
        $('.gallery').modal('show');
    });

    $('.brand-selector').dropdown({
        ignoreCase: true,
        clearable: true,
        fullTextSearch: true,
        forceSelection: false,
        message: {
            noResults: 'Aucune marque trouvée.'
        },
    });

    $('.year-selector').dropdown({
        ignoreCase: true,
        clearable: true,
        fullTextSearch: true,
        forceSelection: false,
        message: {
            noResults: 'Aucune année trouvée.'
        }
    });

    $('.category-selector').dropdown({
        ignoreCase: true,
        clearable: true,
        fullTextSearch: true,
        forceSelection: false,
        message: {
            noResults: 'Aucune catégorie trouvée.'
        }
    });

    setTimeout(function() {
        $('input').on('focus', function() {
            $(this).prop('autocomplete', makeString(20));
        });
        $('input').prop('autocomplete', makeString(20));
    }, 100);

});